module.exports = __webpack_public_path__ + "static/img/508.254648d.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/508.png
// module id = 537
// module chunks = 3